import { render, staticRenderFns } from "./order-shipment-stat.vue?vue&type=template&id=717a6cea&scoped=true"
import script from "./order-shipment-stat.vue?vue&type=script&lang=js"
export * from "./order-shipment-stat.vue?vue&type=script&lang=js"
import style0 from "./order-shipment-stat.vue?vue&type=style&index=0&id=717a6cea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717a6cea",
  null
  
)

export default component.exports